import { createReducer } from 'redux-act';
import { createActions } from './util';
import messageCategory from 'constants/message-category';

export const actions = createActions({
  pushSuccess: 'Push Success Message',
  pushError: 'Push Error Message',
  pop: 'Pop Message',
  dismiss: 'Dismiss Message'
});

export default createReducer(
  {
    [actions.pushSuccess]: (state, message) => [
      ...state,
      { message, category: messageCategory.SUCCESS }
    ],
    [actions.pushError]: (state, message) => [
      ...state,
      { message, category: messageCategory.ERROR }
    ],
    [actions.pop]: state => state.slice(1),
    [actions.dismiss]: (state, index) =>
      state.slice(0, index).concat(state.slice(index + 1))
  },
  []
);



// WEBPACK FOOTER //
// ./src/reducers/messages.js